<template>
  <div class="answer-view" :class="{ hasSection: hasSection, 'all-support': !hasNotSupport }">
    <div class="progress">
      <span class="text">答题卡</span>
      <span>
        <span class="primary-color">{{ index }}</span>
        <span class="total">/{{ total }}</span>
      </span>
    </div>
    <div class="legend">
      <span class="num status-1"></span>
      <span>已答</span>
      <span class="num status-3"></span>
      <span>未答</span>
    </div>
    <el-scrollbar
      :class="{ 'el-scrollbar-hide': !hasScroll }"
      :style="hasScroll ? 'height: calc(100vh - 444px);' : ''"
    >
      <div ref="nums" class="nums">
        <template v-if="hasSection">
          <template v-for="(item, index) in scantron.list">
            <div class="section" :key="'section-' + index">
              {{ item.name }}
            </div>
            <div :key="'nums-' + index">
              <a
                href="javascript:void(0)"
                class="num"
                :class="'status-' + ques.status + ' ' + (ques.is_sign == 1 ? 'sign' : '')"
                v-for="ques in item.child"
                :key="ques.sort"
                @click="goTo(ques.sort)"
              >
                {{ ques.sort }}
              </a>
            </div>
          </template>
        </template>
        <template v-else>
          <a
            href="javascript:void(0)"
            class="num"
            :class="'status-' + ques.status + ' ' + (ques.is_sign == 1 ? 'sign' : '')"
            :key="ques.sort"
            v-for="ques in scantron.list"
            @click="goTo(ques.sort)"
          >
            {{ ques.sort }}
          </a>
        </template>
      </div>
    </el-scrollbar>
  </div>
</template>
<script>
export default {
  name: 'AnswerSheet',
  props: {
    total: {
      type: Number,
      default: 0,
    },
    index: {
      type: Number,
      default: 0,
    },
    scantron: {
      type: Object,
      default: () => {
        return { list: [] };
      },
    },
    hasSection: {
      type: Boolean,
      default: false,
    },
    hasNotSupport: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      hasScroll: false,
    };
  },
  watch: {
    scantron() {
      this.initNums();
    },
  },
  methods: {
    goTo(index) {
      this.$emit('goTo', index);
    },
    initNums() {
      this.$nextTick(() => {
        if (this.$refs.nums.clientHeight > document.documentElement.clientHeight - 444) {
          this.hasScroll = true;
        } else {
          this.hasScroll = false;
        }
      });
    },
  },
  mounted() {
    this.initNums();
  },
};
</script>
<style lang="scss" scoped>
.answer-view {
  border: 1px solid rgba(237, 237, 237, 1);
  border-radius: 5px;
  margin: 20px 0;
  .progress {
    background: #f5f5f5;
    padding: 0 15px 0 18px;
    font-size: 16px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .text {
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
    }
    .primary-color,
    .total {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
    }
  }
  &.hasSection {
    .nums {
      padding-top: 15px;
    }
  }
  .nums {
    padding: 20px 0 0 14px;
    overflow-y: auto;
    box-sizing: border-box;

    .section {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      margin-bottom: 12px;
      padding-top: 7px;
    }
  }
  .num {
    width: 30px;
    height: 30px;
    border-radius: 3px;
    line-height: 30px;
    display: inline-block;
    text-align: center;
    border-radius: 3px;
    color: #333333;
    margin: 0 13px 13px 0;
    cursor: pointer;
    box-sizing: border-box;
    position: relative;
    &.sign::after {
      content: '';
      width: 15px;
      height: 15px;
      background-image: url('~@/assets/images/exam/tag-checked@2x.png');
      background-size: 100% 100%;
      position: absolute;
      left: 20px;
      bottom: 21px;
    }
    &.status-1,
    &.status-2 {
      background-color: $primary-color;
      color: white;

      &:hover {
        background: $primary-color-hover;
      }
    }
    &.status-3 {
      border: 1px solid rgba(232, 232, 232, 1);

      &:hover {
        border-color: $primary-color;
        color: $primary-color;
      }
    }
    &.status-4 {
      background-color: #e0e0e0;
    }
    &:nth-child(5n) {
      margin-right: 0;
    }
  }
  &.all-support {
    .status-4 {
      background-color: $primary-color;
      color: white;

      &:hover {
        background: $primary-color-hover;
      }
    }
  }
  .legend {
    padding-top: 20px;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
    padding-left: 14px;
    .num {
      margin: 0 6px 0 0;
      width: 14px;
      height: 14px;
      cursor: default;
    }
    span:nth-child(2) {
      margin-right: 14px;
    }
    span:nth-child(4) {
      margin-right: 20px;
    }
  }

  .el-scrollbar-hide {
    ::v-deep {
      .el-scrollbar__wrap {
        overflow-x: hidden;
        margin-bottom: 0 !important;
      }
    }
  }

  ::v-deep {
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
}
</style>
